import styled, { AnyStyledComponent } from 'styled-components';

interface StyledBaseSVGProps {
    width: number;
};

export const StyledBaseSVG: AnyStyledComponent = styled.svg`
    width: ${({width}: StyledBaseSVGProps) => width}px;
    display: block;
`;

interface BaseProps {
    tabIndex: number;
};

export const BaseRect: AnyStyledComponent = styled.rect`
    pointer-events: ${({tabIndex}: BaseProps) => tabIndex === 0 ? 'auto' : 'none'};
    cursor: ${({tabIndex}: BaseProps) => tabIndex === 0 ? 'pointer' : 'none'};

    &:focus {
        outline: none;
    }
`;